import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useI18n, useLocalizedPath } from "../i18n/I18nContext";
import { api } from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const { t, lang } = useI18n();
  const lp = useLocalizedPath();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then(({ data }) => setPost(data))
      .catch(() => setPost(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="container mx-auto px-6 py-32 text-center text-white/40">{t.common.loading}</div>;
  if (!post) return <div className="container mx-auto px-6 py-32 text-center font-display text-3xl">404</div>;

  const tr = post.translations[lang];

  return (
    <div className="container mx-auto px-6 py-12 max-w-3xl">
      <Link to={lp("/blog")} className="font-mono-label text-white/40 hover:text-white inline-flex items-center gap-2 mb-12">
        <ArrowLeft className="h-3.5 w-3.5" /> {t.blog.title}
      </Link>

      <div className="font-mono-label text-gold/80 mb-4">
        {post.category} · {post.read_time_min} min
      </div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter leading-[1.05]">{tr.title}</h1>
      <p className="mt-6 ed-italic text-2xl text-white/70">{tr.excerpt}</p>

      <div
        className="aspect-[16/9] my-12 rounded-3xl"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(212,175,55,0.18), rgba(9,9,11,0.6)), url(${post.cover_url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <article className="prose prose-invert max-w-none text-white/80 text-lg leading-relaxed">
        {tr.body.split("\n").map((para, i) => (
          <p key={i} className="mb-6">{para}</p>
        ))}
      </article>
    </div>
  );
}
